<template>
  <HeadlessRadioGroup>
    <div
      class="flex h-full flex-nowrap items-stretch justify-between space-x-1 rounded-md border border-background-fg/8 bg-background p-0.5"
    >
      <HeadlessRadioGroupOption
        v-for="option in options"
        :key="option.label"
        as="template"
      >
        <div
          :class="[
            option.value === modelValue
              ? 'bg-primary text-white'
              : '',
            'flex flex-1 cursor-pointer items-center justify-center rounded-lg px-2 py-1 text-sm',
          ]"
          @click="emit('update:modelValue', option.value)"
        >
          <HeadlessRadioGroupLabel
            as="span"
            class="line-clamp-1 whitespace-nowrap"
          >
            {{ option.label }}
          </HeadlessRadioGroupLabel>
        </div>
      </HeadlessRadioGroupOption>
    </div>
  </HeadlessRadioGroup>
</template>

<script setup lang="ts">
export type WeeklyTransactionSummaryType =
  | "cardTurnover"
  | "activeMerchantCount"
  | "transactionCount"

const props = defineProps<{
  modelValue: WeeklyTransactionSummaryType
}>()

const options = [
  {
    value: "cardTurnover",
    label: "Card Turnover",
  },
  {
    value: "activeMerchantCount",
    label: "Merchant Count",
  },
  {
    value: "transactionCount",
    label: "Transaction Count",
  },
] as const

const emit = defineEmits<{
  (
    eventName: "update:modelValue",
    value: WeeklyTransactionSummaryType
  ): void
}>()
</script>
